<template>
  <div>
    <div
      class="drop-spot-list-dialog"
      :class="{ selected: selected }"
      @click="onClick"
    >
      <img src="@/assets/list.svg" alt="congestion" />
    </div>
    <div v-show="isDialogOpen" class="background" @click="onClose"></div>
    <div v-show="isDialogOpen" class="dialog">
      <div class="item" :key="item.id" v-for="item in filteredSpotList">
        <DropSpotItem
          :selectedSpot="item"
          :current="current"
          @click-spot="onClickSpot"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import DropSpotItem from "@/components/Organisms/DropSpotItem";

export default {
  name: "drop-spot-list-dialog",
  components: {
    ButtonTextLink,
    DropSpotItem,
  },
  props: {
    current: { type: String, default: false, required: true },
    spotList: { type: Array, default: false, required: true },
    selected: { type: Boolean, default: false, required: true },
  },
  computed: {
    ...mapState([
      "selectedFilter",
      "DesLatLng",
      "DepLatLng",
      "selectedSpotType",
    ]),
    currentSelectedFilter() {
      if (this.current === "RouteSearch") {
        return this.selectedFilter.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedFilter.jyutai;
      }
    },
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
    },
    currentSelectedSpotType() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotType.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotType.jyutai;
      }
    },
    filteredSpotList() {
      const currentLat =
        this.current === "RouteSearch"
          ? this.currentDesLatLng.lat()
          : this.currentDepLatLng.lat();
      const currentLng =
        this.current === "RouteSearch"
          ? this.currentDesLatLng.lng()
          : this.currentDepLatLng.lng();
      const filteredSpotList = this.spotList.filter((data) => {
        return (
          this.currentSelectedSpotType === data.category.name &&
          this.getIsDuplicate(
            this.currentSelectedFilter.tag,
            data.tag_spots.map((tag) => tag.tag.id),
          ) &&
          this.compareDistance(
            this.calcDistance(data.lat, data.lon, currentLat, currentLng),
          )
        );
      });

      return filteredSpotList;
    },
  },
  data() {
    return {
      isDialogOpen: false,
    };
  },
  methods: {
    onClick() {
      this.isDialogOpen = true;
    },
    onClose() {
      this.isDialogOpen = false;
    },
    onClickSpot() {
      this.$emit("click-spot");
    },
    compareDistance(distance) {
      if (!this.currentSelectedFilter.distance) return true;
      return distance <= this.currentSelectedFilter.distance;
    },
    calcDistance(targetLat, targetLng, currentLat, currentLng) {
      const R = Math.PI / 180;
      let tmpLat = targetLat;
      let tmpLng = targetLng;
      let tmpCurrentLat = currentLat;
      let tmpCrrentLng = currentLng;
      tmpCurrentLat *= R;
      tmpCrrentLng *= R;
      tmpLat *= R;
      tmpLng *= R;
      return (
        6371 *
        Math.acos(
          Math.cos(tmpCurrentLat) *
            Math.cos(tmpLat) *
            Math.cos(tmpLng - tmpCrrentLng) +
            Math.sin(tmpCurrentLat) * Math.sin(tmpLat),
        ) *
        1000
      );
    },
    getIsDuplicate(arr1, arr2) {
      if (this.currentSelectedFilter.tag.length === 0) return true;
      return (
        [...arr1, ...arr2].filter(
          (item) => arr1.includes(item) && arr2.includes(item),
        ).length > 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.drop-spot-list-dialog {
  text-align: center;
  border-radius: 4px;
  padding-top: 2px 0;
  width: 32px;
  height: 32px;
  position: absolute;
  right: 0.25rem;
  bottom: 3.5rem;
  background: white;
  &.selected {
    bottom: 9rem;
  }
  img {
    height: 30px;
    width: 30px;
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.dialog {
  position: fixed;
  flex-direction: column;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-55%);
  background-color: white;
  z-index: 1001;
  width: calc(100% - 2rem * 2);
  max-height: 80%;
  overflow-y: scroll;
  padding: 1rem;
  border-radius: 12px;

  .item {
    border-bottom: 1px solid #e7e7e7;
    padding: 0.25rem;
    &:last-child {
      border-bottom: none;
    }
  }
}

.description {
  text-align: center;
  font-size: 0.8rem;
  margin: 0.5rem 0;
}

.close {
  margin: 0;
}
.row {
  display: flex;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  .circle {
    height: 2rem;
  }
  .human {
    height: 1.75rem;
    width: 50px;
  }
  .text {
    margin: 0 1rem;
    width: 130px;
    &.congestion {
      display: inline-block;
      width: 80px;
    }
    .small {
      font-size: 0.75rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DropSpotSelect/DropSpotListDialog.vue